/* Wellivea components, part 2: hero slideshow, product finder, bundle add-to-basket. */
(function () {
  if (window.WelliveaMore) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function initSlides(el) {
    if (el.dataset.wvReady) return;
    el.dataset.wvReady = '1';
    var track = el.querySelector('[data-wv-slides-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var dots = Array.prototype.slice.call(el.querySelectorAll('[data-wv-dot]'));
    var prev = el.querySelector('[data-wv-slide-prev]');
    var next = el.querySelector('[data-wv-slide-next]');
    var pauseBtn = el.querySelector('[data-wv-pause]');
    var delay = parseInt(el.getAttribute('data-autoplay') || '0', 10) * 1000;
    var current = 0;
    var timer = null;
    var userPaused = false;
    if (slides.length < 2) return;

    function go(i) {
      current = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[current].offsetLeft - slides[0].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    function sync() {
      var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
      current = Math.max(0, Math.min(slides.length - 1, i));
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === current ? 'true' : 'false'); });
      slides.forEach(function (s, n) { s.inert = n !== current; });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function play() {
      stop();
      if (!delay || reduce || userPaused) return;
      timer = setInterval(function () { if (!document.hidden) go(current + 1); }, delay);
    }
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 80); }, { passive: true });
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    if (pauseBtn) {
      if (!delay || reduce) pauseBtn.hidden = true;
      pauseBtn.addEventListener('click', function () {
        userPaused = !userPaused;
        pauseBtn.setAttribute('data-paused', userPaused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', userPaused ? pauseBtn.getAttribute('data-play-label') : pauseBtn.getAttribute('data-pause-label'));
        if (userPaused) stop(); else play();
      });
    }
    el.addEventListener('mouseenter', stop);
    el.addEventListener('mouseleave', play);
    el.addEventListener('focusin', stop);
    el.addEventListener('focusout', function (e) { if (!el.contains(e.relatedTarget)) play(); });
    el.addEventListener('touchstart', function () { userPaused = true; stop(); }, { passive: true });
    document.addEventListener('shopify:block:select', function (e) {
      var i = slides.indexOf(e.target);
      if (i > -1) { userPaused = true; stop(); go(i); }
    });
    sync();
    play();
  }

  function initFinder(el) {
    if (el.dataset.wvReady) return;
    el.dataset.wvReady = '1';
    el.classList.add('is-ready');
    var steps = el.querySelectorAll('[data-wv-step]');
    var progress = el.querySelectorAll('[data-wv-progress]');
    var started = false;
    function show(n) {
      steps.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-wv-step') === String(n)); });
      progress.forEach(function (p) {
        if (p.getAttribute('data-wv-progress') === String(n)) p.setAttribute('aria-current', 'step');
        else p.removeAttribute('aria-current');
      });
      if (started) {
        var target = el.querySelector('[data-wv-step="' + n + '"] [data-wv-focus]');
        if (target) target.focus();
      }
      started = true;
    }
    el.querySelectorAll('[data-wv-area]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var area = btn.getAttribute('data-wv-area');
        el.querySelectorAll('[data-wv-area]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        el.querySelectorAll('[data-wv-group]').forEach(function (g) { g.hidden = g.getAttribute('data-wv-group') !== area; });
        show(2);
      });
    });
    el.querySelectorAll('[data-wv-option]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-wv-option');
        el.querySelectorAll('[data-wv-result]').forEach(function (r) { r.hidden = r.getAttribute('data-wv-result') !== id; });
        show(3);
      });
    });
    el.querySelectorAll('[data-wv-back]').forEach(function (b) {
      b.addEventListener('click', function () { show(parseInt(b.getAttribute('data-wv-back'), 10)); });
    });
    show(1);
  }

  function initBundles(scope) {
    scope.querySelectorAll('form[data-wv-bundle]').forEach(function (form) {
      if (form.dataset.wvReady) return;
      form.dataset.wvReady = '1';
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var btn = form.querySelector('button[type=submit]');
        var status = form.querySelector('[data-wv-status]');
        var items = Array.prototype.map.call(form.querySelectorAll('.wv-bundle-id'), function (input) {
          return { id: parseInt(input.value, 10), quantity: 1 };
        });
        if (!items.length) return;
        btn.disabled = true;
        if (status) status.textContent = form.getAttribute('data-adding') || '';
        fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
          .then(function () { window.location.href = root + 'cart'; })
          .catch(function (err) {
            btn.disabled = false;
            if (status) status.textContent = (err && err.description) || form.getAttribute('data-error') || '';
          });
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-wv-slides]').forEach(initSlides);
    scope.querySelectorAll('[data-wv-finder]').forEach(initFinder);
    initBundles(scope);
  }

  window.WelliveaMore = { init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
